/** Poster size variants supported by the API. */
export type PosterSize = 'h180' | 'h360' | 'h720';

/**
 * Map from "fragmentId-size" to the first-seen URI for that combo.
 * Lives outside React so it persists across unmount/remount (e.g. when filtering).
 */
const uriCache = new Map<string, string>();

/**
 * Normalizes the poster URI for stable display.
 * For a given fragment + size, the first URI we see is cached and reused.
 * This avoids browser refetches and flicker when the API returns a newer signed URI
 * (e.g. after filtering and re-fetching the same fragment).
 */
export function getStablePosterUri(fragmentId: string, size: PosterSize, newUri: string): string {
  const cacheKey = `${fragmentId}-${size}`;
  if (!uriCache.has(cacheKey)) {
    uriCache.set(cacheKey, newUri);
  }
  return uriCache.get(cacheKey)!;
}

/**
 * Clears the poster URI cache. Call when doing a manual refresh or periodically
 * (e.g. every 30 min) so that long-lived sessions don't keep using expired signed URLs.
 */
export function clearPosterCache(): void {
  uriCache.clear();
}
